import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { firstValueFrom, from, map } from 'rxjs';
import { PasajerosDialogComponent } from 'src/app/file/biblia/pasajeros-dialog/pasajeros-dialog.component';
import { convertToLocalISO } from 'src/app/helpers/datesFormat';
import { AventuraService } from 'src/app/services/api/aventura.service';
import { FileService } from 'src/app/services/api/file.service';
import { ProveddoresProjectExpression } from 'src/entities/file/model/service-projection';
import { flattenStrings } from 'src/shared/lib';
import { AsignacionPersonalComponent } from './asignacion-personal/asignacion-personal.component';

@Component({
  selector: 'app-programacion-personal-campo',
  templateUrl: './programacion-personal-campo.component.html',
  styleUrls: ['./programacion-personal-campo.component.css']
})
export class ProgramacionPersonalCampoComponent
  implements OnInit, AfterViewInit
{
  cuscoDisplayedColumns: string[] = [
    'comunidad',
    'fechaInicioProducto',
    'fecha-fin',
    'file',
    'tipoFile',
    'nameClient',
    'fileDisplayState',
    'nombreItinerario',
    'passengers',
    'pax&tc',
    'ruta',
    'porteador',
    'cocinero',
    'porteador-extra',
    'trp',
    'jefe-arriero',
    'arriero-carga',
    'acemila-carga',
    'arriero-silla',
    'acemila-silla',
    'carpero-banero',
    'guia',
    'chofer',
    'doctor',
    'asist-picnic',
    'comfort'
  ];

  huarazDisplayedColumns: string[] = [
    'comunidad',
    'fechaInicioProducto',
    'fecha-fin',
    'file',
    'tipoFile',
    'nameClient',
    'fileDisplayState',
    'nombreItinerario',
    'passengers', // <- Pasajeros asignados
    'pax&tc', // <- Nueva columna para mostrar PAX y TC juntos
    'ruta',
    // 'porteador',
    'cocinero',
    // 'porteador-extra',
    // 'trp',
    'jefe-arriero',
    'arrieros',
    // 'arriero-carga',
    // 'arriero-silla',
    'acemila',
    // 'acemila-carga',
    // 'acemila-silla',
    'carpero-banero',
    'guia',
    'chofer',
    // 'doctor',
    // 'asist-picnic',
    'comfort'
  ];

  dataSource: any;
  loading: boolean = true;
  tableData: any;
  location: any;
  comunidades: string[] = [];

  searchValue: null | string = '';
  selectedFile: string | null = null;
  selectedRoutes: string[] = [];
  searchRouteQuery: string = '';
  startDate: Date | any;
  endDate: Date | any;

  startDateFileSelected: Date | any;
  endDateFileSelected: Date | any;
  availableFileNumbers: any = [];
  availableProductRoutes: any = [];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private service: AventuraService,
    private fileService: FileService,
    private route: ActivatedRoute,
    public dialog: MatDialog
  ) {}

  isLoading: boolean = false;
  porteadorData: any;
  cocineroData: any;

  availableProviders: any;
  providersByComunidad: any = {};
  cocinerosByComunidad: any = {};

  showProvidersList: boolean = false;
  providersList: string[] = [];
  porteadorDataFilter: any;
  cocineroDataFilter: any;

  providersExplorandes: string[] = [
    '11a379ee-25c1-41a7-98c6-b23b6a3a449f',
    'c5e1cfc2-1b3e-4d7b-858e-4fd008f3fe88',
    'z9e1cfc2-1b3e-4d7b-858e-4fd008f3fe23'
  ];

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource();

    const today = new Date();
    const nextMonth = new Date();
    nextMonth.setMonth(today.getMonth() + 1);

    this.startDate = today;
    this.endDate = nextMonth;

    this.route.params.subscribe((params) => {
      this.location = params['location'];

      if (this.location?.toLowerCase() === 'cusco') {
        this.comunidades = [
          'CAMICANCHA',
          'HUILLOQ',
          'LAMAY',
          'SOCMA',
          'POROY',
          'OCONGATE',
          'MACHU PICCHU'
        ];
      } else if (this.location?.toLowerCase() === 'huaraz') {
        this.comunidades = [
          'CORDILLERA BLANCA',
          'CORDILLERA HUAYHUASH',
          'HUARAZ'
        ];
      } else {
        this.comunidades = [];
      }

      this.getAllServicesInFiles(
        convertToLocalISO(this.startDate),
        convertToLocalISO(this.endDate)
      );
    });
    this.loadProgramacionPersonalCampo();
  }

  async getAllPoviders() {
    try {
      const data: any = await firstValueFrom(
        this.fileService.getAllProvidersWithProjectionExpression(
          ProveddoresProjectExpression.join(',')
        )
      );

      return data.getAllProvidersWithProjectionExpression ?? [];
    } catch (error: any) {
      throw new Error(error);
    }
  }

  ngAfterViewInit() {
    // Personaliza el sortingDataAccessor para manejar el formato de fecha
    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      if (property === 'fechaInicioProducto') {
        if (item.fechaInicioProducto) {
          const [day, month, year] = item.fechaInicioProducto
            .split('/')
            .map(Number);
          return new Date(year, month - 1, day).getTime(); // Devuelve tiempo en milisegundos para ordenar
        }
        return 0; // Si la fecha no existe, retorna un valor predeterminado
      }
      return item[property]; // Ordenamiento normal para otros campos
    };
    this.dataSource.sort = this.sort;
  }

  openDialogPasajeros(lstPaX: any[]) {
    this.dialog.open(PasajerosDialogComponent, {
      width: '96vw',
      height: '600px',
      data: lstPaX
    });
  }

  loadProgramacionPersonalCampo() {
    this.service
      .getAllProveedoresByType('PERSONALDECAMPO')
      .subscribe((personalDeCampoProviders) => {
        this.availableProviders = personalDeCampoProviders.getAllProviderByType;

        this.availableProviders = this.availableProviders.filter(
          (provider: any) =>
            this.comunidades.includes(provider.personalCampoInfo?.comunidad)
        );

        if (!Array.isArray(this.availableProviders)) {
          return;
        }

        this.porteadorData = this.availableProviders.filter(
          (provider: any) =>
            this.comunidades.includes(provider.personalCampoInfo?.comunidad) &&
            (provider.categoriaProveedor === 'PORTEADOR' ||
              provider.categoriaProveedor === 'PORTEADORBAÑERO' ||
              provider.categoriaProveedor === 'PORTEADORMENAJERO' ||
              provider.categoriaProveedor === 'PORTEADOREXTRA' ||
              provider.categoriaProveedor === 'JEFEPORTEADOR')
        );

        this.cocineroData = this.availableProviders.filter(
          (provider: any) =>
            //this.comunidades.includes(provider.personalCampoInfo?.comunidad) &&
            provider.categoriaProveedor === 'COCINERO' ||
            provider.categoriaProveedor === 'ASISTENTECOCINA'
        );

        this.calcularFechasDisponibles();
      });
  }

  calcularFechasDisponibles() {
    const fechaActual = new Date();

    this.porteadorDataFilter = this.porteadorData.filter((item: any) => {
      if (item.fechasOcupadas?.length > 0) {
        const result = item.fechasOcupadas?.map((provider: any) => {
          if (provider.fechaFin) {
            const fechaFinParts = provider.fechaFin?.split('/');
            const fechaFin = new Date(
              parseInt(fechaFinParts[2]),
              parseInt(fechaFinParts[1]) - 1,
              parseInt(fechaFinParts[0])
            );
            return fechaFin;
          } else return;
        });

        const dateProvider = result.every(
          (fechaFin: any) => fechaActual > fechaFin
        );

        if (dateProvider) {
          return item;
        }
      } else return item;
    });

    this.cocineroDataFilter = this.cocineroData.filter((item: any) => {
      if (item.fechasOcupadas?.length > 0) {
        const result = item.fechasOcupadas.map((provider: any) => {
          const fechaFinParts = provider.fechaFin?.split('/');
          if (!fechaFinParts || fechaFinParts.length !== 3) {
            return null; // O maneja el error de la forma que prefieras
          }
          const fechaFin = new Date(
            parseInt(fechaFinParts[2]),
            parseInt(fechaFinParts[1]) - 1,
            parseInt(fechaFinParts[0])
          );
          return fechaFin;
        });

        const dateProvider = result.every(
          (fechaFin: any) => fechaActual > fechaFin
        );

        if (dateProvider) {
          return item;
        }
      } else return item;
    });

    this.providersByComunidad = this.porteadorDataFilter.reduce(
      (agrupados: any, item: any) => {
        const comunidad = item?.personalCampoInfo?.comunidad;
        if (comunidad) {
          if (!agrupados[comunidad]) {
            agrupados[comunidad] = [];
          }
          agrupados[comunidad].push(item);
        }
        return agrupados;
      },
      {}
    );

    this.cocinerosByComunidad = this.cocineroDataFilter.reduce(
      (agrupados: any, item: any) => {
        const comunidad = item?.personalCampoInfo?.comunidad;
        if (comunidad) {
          if (!agrupados[comunidad]) {
            agrupados[comunidad] = [];
          }
          agrupados[comunidad].push(item);
        }

        return agrupados;
      },
      {}
    );
  }

  showProviders(comunidad: string): void {
    this.providersList = this.providersByComunidad[comunidad];
    this.showProvidersList = true;
  }

  hideProvidersList(): void {
    this.showProvidersList = false;
  }

  async getAllServicesInFilesPaginated({
    startDate = null,
    endDate = null
  }: {
    startDate: string | null;
    endDate: string | null;
  }) {
    try {
      let lastEvaluatedKey: string | null = null;
      let fileServices: any[] = [];
      do {
        const getProductsAventuraResponse: {
          getProductsAventura: {
            productos: any[];
            lastEvaluatedKeyId: string | null;
          };
        } = await firstValueFrom(
          this.fileService.getProductsAventura({
            startDate,
            endDate,
            location: this.location,
            exclusiveStartKeyId: lastEvaluatedKey
          })
        );
        console.log('fileServices', fileServices);
        fileServices = fileServices.concat(
          getProductsAventuraResponse?.getProductsAventura?.productos || []
        );
        lastEvaluatedKey =
          getProductsAventuraResponse?.getProductsAventura
            ?.lastEvaluatedKeyId || null;
      } while (lastEvaluatedKey);

      return fileServices;
    } catch (error) {
      console.error('Error fetching paginated services:', error);
      return [];
    }
  }

  async getAllServicesInFiles(
    startDate: string | null,
    endDate: string | null
  ) {
    this.loading = true;
    from(
      this.getAllServicesInFilesPaginated({
        startDate,
        endDate
      })
    )
      .pipe(
        map((productos) => {
          const productlist = productos?.map((producto: any) => {
            producto.comunidadAux = producto.comunidad;
            if (producto.services && Array.isArray(producto.services)) {
              producto.services.forEach((s: any) => {
                s.hasOS = Boolean(
                  s.orderId
                );
              });
            }
            const serviciosPorteador = producto.services.filter(
              (service: any) =>
                (service.categoriaServicio === 'PORTEADOR' ||
                  service.categoriaServicio === 'PORTEADORMENAJERO' ||
                  service.categoriaServicio === 'JEFEPORTEADOR' ||
                  service.categoriaServicio === 'PORTEADORBAÑERO') &&
                !service.nombreServicio.includes('EXTRA') &&
                !service.nombreServicio.includes('PICNIC')
            );

            const serviciosPorteadorUnique =
              this.showUniqueProductServices(serviciosPorteador);

            const serviciosPorteadorExtra = producto.services.filter(
              (service: any) => service.categoriaServicio === 'PORTEADOREXTRA'
            );
            const serviciosPorteadorExtraUnique =
              this.showUniqueProductServices(serviciosPorteadorExtra);

            const serviciosTransporte = producto.services.filter(
              (service: any) =>
                service.tipoServicio === 'TRANSPORTE' &&
                service.nombreServicio.includes('EXCESO')
            );
            const serviciosTransporteUnique =
              this.showUniqueProductServices(serviciosTransporte);

            // CARPERO - BAÑERO
            const serviciosCarperoBanero = producto.services.filter(
              (service: any) => {
                if (this.location?.toLowerCase() === 'huaraz') {
                  return service.categoriaServicio === 'BAÑERO';
                }

                return (
                  (service.categoriaServicio === 'CARPERO' ||
                    service.categoriaServicio === 'BAÑERO') &&
                  !service.nombreServicio.includes('EXTRA') &&
                  !service.nombreServicio.includes('PICNIC')
                );
              }
            );
            const serviciosCarperoBaneroUnique = this.showUniqueProductServices(
              serviciosCarperoBanero
            );

            let serviciosJefeArriero = [];
            let serviciosJefeArrieroUnique = [];
            if (this.location?.toLowerCase() === 'cusco') {
              serviciosJefeArriero = producto.services.filter(
                (service: any) => service.categoriaServicio === 'JEFEARRIERO'
              );
              serviciosJefeArrieroUnique =
                this.showUniqueProductServices(serviciosJefeArriero);
            }
            if (this.location?.toLowerCase() === 'huaraz') {
              serviciosJefeArriero = producto.services.filter(
                (service: any) => service.categoriaServicio === 'JEFEARRIERO'
              );
              serviciosJefeArrieroUnique =
                this.showUniqueProductServices(serviciosJefeArriero);
            }

            const serviciosCocinero = producto.services.filter(
              (service: any) =>
                service.categoriaServicio === 'COCINERO' ||
                service.categoriaServicio === 'ASISTENTECOCINA'
            );
            const serviciosCocineroUnique =
              this.showUniqueProductServices(serviciosCocinero);

            const serviciosGuia = producto.services.filter(
              (service: any) => service.tipoServicio === 'GUIA'
            );
            const serviciosGuiaUnique =
              this.showUniqueProductServices(serviciosGuia);

            // ARRIEROS
            const serviciosArrieroCarga = producto.services.filter(
              (service: any) =>
                (service.categoriaServicio === 'ARRIERO' &&
                  service.nombreServicio.includes('CARGA')) ||
                service.categoriaServicio === 'ARRIEROCARGA'
            );
            const serviciosArrieroCargaUnique = this.showUniqueProductServices(
              serviciosArrieroCarga
            );

            const serviciosArrieroSilla = producto.services.filter(
              (service: any) =>
                (service.categoriaServicio === 'ARRIERO' &&
                  service.nombreServicio.includes('SILLA')) ||
                service.categoriaServicio === 'ARRIEROSILLA'
            );
            const serviciosArrieroSillaUnique = this.showUniqueProductServices(
              serviciosArrieroSilla
            );

            const serviciosArrieros = producto.services.filter(
              (service: any) =>
                service.categoriaServicio === 'ARRIERO' ||
                service.categoriaServicio === 'ARRIEROCABALLO' ||
                service.categoriaServicio === 'ARRIEROCARGA' ||
                service.categoriaServicio === 'ARRIEROSILLA'
            );
            const serviciosArrierosUnique =
              this.showUniqueProductServices(serviciosArrieros);

            // ACEMILA
            const serviciosAcemilaCarga = producto.services.filter(
              (service: any) =>
                (service.categoriaServicio === 'ACEMILA' &&
                  service.nombreServicio.includes('CARGA')) ||
                service.categoriaServicio === 'ACEMILACARGA'
            );
            const serviciosAcemilaCargaUnique = this.showUniqueProductServices(
              serviciosAcemilaCarga
            );
            const serviciosAcemilaSilla = producto.services.filter(
              (service: any) =>
                (service.categoriaServicio === 'ACEMILA' &&
                  service.nombreServicio.includes('SILLA')) ||
                service.categoriaServicio === 'ACEMILASILLA'
            );
            const serviciosAcemilaSillaUnique = this.showUniqueProductServices(
              serviciosAcemilaSilla
            );

            const serviciosAcemila = producto.services.filter(
              (service: any) =>
                service.categoriaServicio === 'ACEMILA' ||
                service.categoriaServicio === 'ACEMILACARGA' ||
                service.categoriaServicio === 'ACEMILASILLA' ||
                service.categoriaServicio === 'OTROS' // <- Incluye "OTROS" para mostrar a los caballos de emergencia SOLO Huaraz
            );

            const serviciosAcemilaUnique =
              this.showUniqueProductServices(serviciosAcemila);

            // CHOFER
            const serviciosChofer = producto.services.filter(
              (service: any) => service.categoriaServicio === 'CHOFER'
            );
            const serviciosChoferUnique =
              this.showUniqueProductServices(serviciosChofer);
            const serviciosDoctor = producto.services.filter(
              (service: any) => service.categoriaServicio === 'DOCTOR'
            );
            const serviciosDoctorUnique =
              this.showUniqueProductServices(serviciosDoctor);
            const serviciosAsisPicnic = producto.services.filter(
              (service: any) =>
                service.categoriaServicio === 'ASISTENTEDEPICNIC'
            );
            const serviciosAsisPicnicUnique =
              this.showUniqueProductServices(serviciosAsisPicnic);
            const serviciosComfort = producto.services.filter(
              (service: any) =>
                service.categoriaServicio === 'PARAMEDICO' ||
                service.categoriaServicio === 'DOCTOR' ||
                service.categoriaServicio === 'CHEF' ||
                service.categoriaServicio === 'MASAJISTA'
            );
            const serviciosComfortUnique =
              this.showUniqueProductServices(serviciosComfort);

            const productLstPax = [
              ...(producto.pax || []),
              ...(producto.TC || [])
            ];

            return {
              ...producto,
              lstPaX: productLstPax.map((passenger: any) => ({
                estado: true,
                passengerId: passenger.id
              })),
              serviciosPorteador,
              serviciosPorteadorUnique,
              serviciosPorteadorExtra,
              serviciosPorteadorExtraUnique,
              serviciosTransporte,
              serviciosTransporteUnique,

              serviciosCarperoBanero,
              serviciosCarperoBaneroUnique,

              serviciosJefeArriero,
              serviciosJefeArrieroUnique,
              serviciosCocinero,
              serviciosCocineroUnique,
              serviciosGuia,
              serviciosGuiaUnique,
              serviciosArrieroCarga,
              serviciosArrieroCargaUnique,
              serviciosArrieroSilla,
              serviciosArrieroSillaUnique,

              serviciosArrieros,
              serviciosArrierosUnique,

              serviciosAcemilaCarga,
              serviciosAcemilaCargaUnique,
              serviciosAcemilaSilla,
              serviciosAcemilaSillaUnique,

              serviciosAcemila,
              serviciosAcemilaUnique,

              serviciosChofer,
              serviciosChoferUnique,
              serviciosDoctor,
              serviciosDoctorUnique,
              serviciosAsisPicnic,
              serviciosAsisPicnicUnique,
              serviciosComfort,
              serviciosComfortUnique
            };
          });
          return productlist;
        })
      )
      .subscribe(async (result) => {
        let sortedActivityProducts = result.sort((a: any, b: any) => {
          // Convierte fechas al formato YYYY/MM/DD y luego a objetos Date
          const parseDate = (date: string) => {
            if (!date) return new Date(0);
            const [day, month, year] = date.split('/').map(Number);
            return new Date(year, month - 1, day); // `month - 1` porque los meses son 0-indexados
          };

          const fechaInicioA = parseDate(a.fechaInicioProducto);
          const fechaInicioB = parseDate(b.fechaInicioProducto);

          return fechaInicioB.getTime() - fechaInicioA.getTime(); // Ordena por milisegundos
        });

        // Filtrar localmente por fechaInicioProducto para ser exactos con la selección del usuario
        if (this.startDate || this.endDate) {
          const parseDateOnly = (dateStr: string) => {
            const [day, month, year] = dateStr.split('/').map(Number);
            return new Date(year, month - 1, day).getTime();
          };

          sortedActivityProducts = sortedActivityProducts.filter(
            (activityProduct: any) => {
              if (!activityProduct.fechaInicioProducto) return true;
              const prodTime = parseDateOnly(
                activityProduct.fechaInicioProducto
              );

              let isValid = true;
              if (this.startDate) {
                const startLocal = new Date(this.startDate);
                startLocal.setHours(0, 0, 0, 0);
                if (prodTime < startLocal.getTime()) isValid = false;
              }
              if (this.endDate) {
                const endLocal = new Date(this.endDate);
                endLocal.setHours(23, 59, 59, 999);
                if (prodTime > endLocal.getTime()) isValid = false;
              }
              return isValid;
            }
          );
        }

        const activityProductFiles = sortedActivityProducts.map(
          (activityProduct: any) => activityProduct.fileNumber
        );
        const activityProductNames = sortedActivityProducts.map(
          (activityProduct: any) =>
            activityProduct.objProducto
              ? activityProduct.objProducto.nombre
              : 'OTROS'
        );

        this.availableFileNumbers = [...new Set(activityProductFiles)];
        this.availableProductRoutes = [...new Set(activityProductNames)].sort(
          (a: any, b: any) =>
            a.localeCompare(b, 'es', { numeric: true, sensitivity: 'base' })
        );

        this.tableData = sortedActivityProducts;
        this.dataSource.data = sortedActivityProducts;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.loading = false;
      });
  }

  getInfoSSFF(filesHijos: any[], TC: any[]): string {
    const tcInfo =
      TC?.length > 0
        ? `TC:\n\n${TC.map(
            (tc) => `Nombre: ${tc.firstName} ${tc.lastName}\n`
          ).join('\n')}`
        : 'No hay TC asignado';

    const filesHijosInfo =
      filesHijos.length > 0
        ? `📁 Files Hijos:\n\n${filesHijos
            .map((file) => {
              const guias = file.services
                .map((service: any) =>
                  service.objProvider?.nombre === 'EXPLORANDES CUSCO'
                    ? null
                    : `   - 👤 ${service.objProvider?.nombre || 'Sin nombre'}`
                )
                .filter(Boolean) // Elimina los `null` o `undefined`
                .join('\n');

              return `🔹 File Number: ${file.fileNumber}
      👥 Cliente: ${file.nameClient}
      🗺️ Itinerario: ${file.nombreItinerario}
      📦 Guías:
      ${guias}\n`;
            })
            .join('\n')}`
        : '🚫 No hay files hijos.';

    return `${tcInfo}\n\n${filesHijosInfo}`;
  }

  getTCInfo(TC: any[]): string {
    return TC?.length > 0
      ? `TC:\n\n${TC.map(
          (tc) => `Nombre: ${tc.firstName} ${tc.lastName}\n`
        ).join('\n')}`
      : 'No hay TC asignado';
  }

  /*   async getComunidadByProductId(itineraryId: any, objProducto: any) {
      try {
        const data = await firstValueFrom(this.fileService.getItineraryById(itineraryId));
        const getcomunidad = data?.getItinerary?.comunidades?.find((item: any) => item.productId == objProducto.id);
        if (getcomunidad) {
          return getcomunidad?.comunidad;
        }
        return null

      } catch (error) {
        console.error('Error al obtener la comunidad:', error);
        throw error;
      }
    } */

  splitDate(dateRange: string, rango: boolean) {
    const date = dateRange.split('-');
    return date[rango ? 0 : 1].trim();
  }

  openDialog(
    index: any,
    rowData: any,
    serviceCategory: string,
    servicios: any,
    serviciosUnique: any,
    comunidad: string | null = null
  ) {
    let dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      productAventura: rowData,
      serviceCategory: serviceCategory,
      servicios: servicios,
      serviciosUnique: serviciosUnique,
      comunidad: comunidad,
      location: this.location
    };

    dialogConfig.width = '1200px';

    let dialogRef = this.dialog.open(AsignacionPersonalComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result) return;

      result.added?.map((el: any) => {
        if (serviceCategory === 'PORTEADOR') {
          console.log('EL: ', el);
          console.log('this.porteadorData: ', this.porteadorData);
          this.porteadorData.map((item: any) => {
            if (item.id === el.id) {
              item.fechasOcupadas = el.fechasOcupadas;
            }
          });
        } else if (serviceCategory === 'COCINERO') {
          this.cocineroData.map((item: any) => {
            if (item.id === el.id) {
              item.fechasOcupadas = el.fechasOcupadas;
            }
          });
        }
      });

      result.deleted?.map((el: any) => {
        if (serviceCategory === 'PORTEADOR') {
          this.porteadorData.map((item: any) => {
            if (item.id === el.id) {
              item.fechasOcupadas = el.fechasOcupadas;
            }
          });
        } else if (serviceCategory === 'COCINERO') {
          this.cocineroData.map((item: any) => {
            if (item.id === el.id) {
              item.fechasOcupadas = el.fechasOcupadas;
            }
          });
        }
      });

      this.calcularFechasDisponibles();

      switch (serviceCategory) {
        case 'PORTEADOR':
          this.dataSource.data[index].serviciosPorteador = [...result.services];
          this.dataSource.data[index].serviciosPorteadorUnique =
            this.showUniqueProductServices(
              this.dataSource.data[index].serviciosPorteador
            );
          break;

        case 'PORTEADOREXTRA':
          this.dataSource.data[index].serviciosPorteadorExtra = [
            ...result.services
          ];
          this.dataSource.data[index].serviciosPorteadorExtraUnique =
            this.showUniqueProductServices(
              this.dataSource.data[index].serviciosPorteadorExtra
            );
          break;

        case 'TRANSPORTE':
          Object.assign(
            this.dataSource.data[index].serviciosTransporte,
            result.services
          );
          break;

        case 'CARPEROBANERO':
          Object.assign(
            this.dataSource.data[index].serviciosCarperoBanero,
            result.services
          );
          break;

        case 'BAÑERO':
          Object.assign(
            this.dataSource.data[index].serviciosCarperoBanero,
            result.services
          );
          break;

        case 'CARPEROEXTRA':
          Object.assign(
            this.dataSource.data[index].serviciosCarperoBaneroExtra,
            result.services
          );
          break;

        case 'JEFEARRIERO':
          Object.assign(
            this.dataSource.data[index].serviciosJefeArriero,
            result.services
          );
          break;

        case 'COCINERO':
          Object.assign(
            this.dataSource.data[index].serviciosCocinero,
            result.services
          );
          break;

        case 'ASISTENTECOCINA':
          Object.assign(
            this.dataSource.data[index].serviciosAsisCocina,
            result.services
          );
          break;

        case 'GUIA':
          Object.assign(
            this.dataSource.data[index].serviciosGuia,
            result.services
          );
          break;

        case 'ARRIERO':
          Object.assign(
            this.dataSource.data[index].serviciosArrieros,
            result.services
          );
          break;

        case 'ARRIEROCARGA':
          Object.assign(
            this.dataSource.data[index].serviciosArrieroCarga,
            result.services
          );
          break;

        case 'ARRIEROCABALLOSILLA':
          Object.assign(
            this.dataSource.data[index].serviciosArrieroSilla,
            result.services
          );
          break;

        case 'ACEMILA':
          Object.assign(
            this.dataSource.data[index].serviciosAcemila,
            result.services
          );
          break;

        case 'ACEMILACARGA':
          Object.assign(
            this.dataSource.data[index].serviciosAcemilaCarga,
            result.services
          );
          break;

        case 'ACEMILASILLA':
          Object.assign(
            this.dataSource.data[index].serviciosAcemilaSilla,
            result.services
          );
          break;

        case 'CHOFER':
          Object.assign(
            this.dataSource.data[index].serviciosChofer,
            result.services
          );
          break;

        case 'DOCTOR':
          Object.assign(
            this.dataSource.data[index].serviciosDoctor,
            result.services
          );
          break;

        case 'ASISTENTEDEPICNIC':
          Object.assign(
            this.dataSource.data[index].serviciosAsisPicnic,
            result.services
          );
          break;

        case 'COMFORT':
          Object.assign(
            this.dataSource.data[index].serviciosComfort,
            result.services
          );
          break;

        default:
          break;
      }

      if (this.dataSource.data[index]?.services && Array.isArray(result.services)) {
        const updatedMap = new Map<string, any>(result.services.map((s: any) => [s.id, s]));
        this.dataSource.data[index].services.forEach((s: any) => {
          const updated = updatedMap.get(s.id);
          if (updated) {
            s.providerId = updated.providerId;
            s.orderId = updated.orderId ?? s.orderId;
            s.numOS = updated.numOS ?? s.numOS;
          }
        });
      }
      this.dataSource.data = [...this.dataSource.data];
    });
  }

  calculateFecha(fecha: string, addDays: any) {
    // Parsear la fecha en formato "DD/MM/YYYY"
    const fechaLiberacion = moment(fecha, 'DD/MM/YYYY');

    // Sumar 5 días a la fecha
    const nuevaFecha = fechaLiberacion.clone().add(addDays, 'days');

    // Formatear la nueva fecha de regreso a una cadena
    return nuevaFecha.format('DD/MM/YYYY');
  }

  async saveComunidadByProduct(
    element: any,
    id: any,
    productId: any,
    comunidad: any
  ) {
    if (!element.objProducto) {
      element.comunidad = [...element.comunidadAux];
    } else {
      const result = this.fileService.changeItinerarioComunidad(
        id,
        productId,
        comunidad
      );
      result.subscribe(
        (data) => {
          element.comunidadAux = element.comunidad;
          this.dataSource.data.map((el: any) => {
            if (!el.objProducto) {
              el.comunidad = element.comunidad;
              el.comunidadAux = element.comunidad;
            }
          });
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }

  onApplyRangeSelectedFile() {
    const formatLocal = (d: any) => {
      if (!d) return null;
      const date = new Date(d);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}T00:00:00.000`;
    };

    // Handle cases where only startDate or only endDate is selected
    this.startDateFileSelected = formatLocal(this.startDate);
    this.endDateFileSelected = formatLocal(this.endDate);

    this.getAllServicesInFiles(
      this.startDateFileSelected,
      this.endDateFileSelected
    );
  }

  applyFilterSelect() {
    let filteredActivityProducts: any = this.tableData;

    if (this.searchValue && this.searchValue.trim() !== '') {
      const terms = this.searchValue
        .toLowerCase()
        .split(' ')
        .filter((t) => t);

      filteredActivityProducts = filteredActivityProducts.filter(
        (activityProduct: any) => {
          const allValues = flattenStrings(activityProduct);
          return terms.every((term) =>
            allValues.some((val) => val.includes(term))
          );
        }
      );
    }
    if (this.selectedFile) {
      filteredActivityProducts = filteredActivityProducts?.filter(
        (activityProduct: any) => {
          return activityProduct.fileNumber === this.selectedFile;
        }
      );
    }

    if (this.selectedRoutes && this.selectedRoutes.length > 0) {
      const selectedRutas = Array.isArray(this.selectedRoutes)
        ? this.selectedRoutes
        : [this.selectedRoutes];
      const hasOtros = selectedRutas.includes('OTROS');

      filteredActivityProducts = filteredActivityProducts?.filter(
        (activityProduct: any) => {
          if (hasOtros && activityProduct.objProducto === null) {
            return true;
          }
          return selectedRutas.some(
            (ruta: string) => activityProduct.objProducto?.nombre === ruta
          );
        }
      );
    }

    this.dataSource.data = filteredActivityProducts;
  }

  cleanDateSelected() {
    this.startDate = null;
    this.endDate = null;
    this.startDateFileSelected = null;
    this.endDateFileSelected = null;

    // Fetch all data without date filters
    this.getAllServicesInFiles(null, null);
  }

  calculateTotalServices(services: any) {
    const uniqueServices = services;

    let daysInServices: any[] = [];

    let sum = 0;

    uniqueServices.map((service: any, index: any) => {
      let daysService = service.days;

      if (index === 0) {
        sum += service?.cantPersonal ?? 1;
        daysService.map((day: any) => {
          if (!daysInServices.includes(day)) {
            daysInServices.push(day);
          }
        });
      } else {
        if (daysInServices.some((day) => daysService.includes(day))) {
          sum += service?.cantPersonal ?? 1;
        }

        daysService.map((day: any) => {
          if (!daysInServices.includes(day)) {
            daysInServices.push(day);
          }
        });
      }
    });

    return sum;
  }

  calculateTotalServicesGUIA(services: any) {
    return services.length;
  }

  countServiciosConOS(services: any[]): number {
    if (!services || !Array.isArray(services)) return 0;
    const conOS = services.filter(
      (s: any) =>
        Boolean(s.orderId)
    );
    const uniqueProvidersConOS = new Set(
      conOS
        .map((s: any) => s.providerId)
        .filter((id: any) => id && !this.providersExplorandes.includes(id))
    );
    return uniqueProvidersConOS.size;
  }

  getCategoryTooltip(services: any[], uniqueServices: any[]): string {
    const assigned = this.calculateTotalServices_(services, uniqueServices);
    const total = this.calculateTotalServices(uniqueServices);
    const conOS = this.countServiciosConOS(services);
    return `${assigned} de ${total} asignados${conOS > 0 ? ` (${conOS} con OS)` : ''}`;
  }

  calculateTotalServices_(services: any, arr: any) {
    const uniqueProviders = [
      ...new Set(services.map((srv: any) => srv.providerId))
    ];

    // const uniqueProviders = services.map((srv: any) => ({ providerId: srv.providerId, day: srv.day }))
    const result = uniqueProviders.filter(
      (item: any) => !this.providersExplorandes.includes(item)
    );

    return result.length;
  }

  getServiceKey(s: any): string {
    if (s?.nombreServicio) {
      return `${s.nombreServicio}_${s.categoriaServicio || ''}`;
    }
    return s?.serviceId || s?.id;
  }

  isSameService(a: any, b: any): boolean {
    if (!a || !b) return false;
    if (a.nombreServicio && b.nombreServicio && a.nombreServicio === b.nombreServicio) {
      if (a.categoriaServicio && b.categoriaServicio) {
        return a.categoriaServicio === b.categoriaServicio;
      }
      return true;
    }
    return Boolean(a.serviceId && b.serviceId && a.serviceId === b.serviceId);
  }

  showUniqueProductServices(services: any[]): any[] {
    const uniqueKeys = new Set<string>();
    const existingServices: any[] = [];

    for (const service of services) {
      const key = this.getServiceKey(service);
      if (!uniqueKeys.has(key)) {
        uniqueKeys.add(key);
        service.days = [service.day];
        existingServices.push(service);
      } else {
        const existingService = existingServices.find(
          (s) => this.getServiceKey(s) === key
        );

        if (existingService) {
          if (!existingService.days.includes(service.day)) {
            existingService.days.push(service.day);
          }
          if (
            this.providersExplorandes &&
            this.providersExplorandes.includes(service.providerId)
          ) {
            existingService.serviceId = service.serviceId;
          }
        }
      }
    }

    existingServices.forEach((serviceItem) => {
      serviceItem.days.sort((a: string, b: string) => {
        return parseInt(a, 10) - parseInt(b, 10);
      });
      const same = services.filter((s: any) =>
        this.isSameService(s, serviceItem)
      );
      const conOS = same.filter((s: any) =>
        Boolean(s.orderId)
      );
      serviceItem.serviciosConOSCount = new Set(
        conOS.map((s: any) => s.providerId).filter(Boolean)
      ).size;
      serviceItem.hasOS = serviceItem.serviciosConOSCount > 0;
    });

    return existingServices.filter(
      (serviceItem) => serviceItem.cantPersonal !== 0
    );
  }

  normalizeText(text?: string): string {
    return (text || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  onSearchRoute(text: string): void {
    this.searchRouteQuery = text;
  }

  clearSearchRoute(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    this.searchRouteQuery = '';
  }

  isRouteVisible(route: string): boolean {
    if (!this.searchRouteQuery || !this.searchRouteQuery.trim()) {
      return true;
    }
    return this.normalizeText(route).includes(
      this.normalizeText(this.searchRouteQuery)
    );
  }

  hasVisibleRoutes(): boolean {
    if (
      !this.availableProductRoutes ||
      this.availableProductRoutes.length === 0
    ) {
      return false;
    }
    if (!this.searchRouteQuery || !this.searchRouteQuery.trim()) {
      return true;
    }
    return this.availableProductRoutes.some((r: string) =>
      this.isRouteVisible(r)
    );
  }

  onRoutesDropdownOpened(isOpen: boolean): void {
    if (isOpen) {
      setTimeout(() => {
        const panel = document.querySelector('.custom-filter-select-panel');
        if (panel) {
          panel.scrollTop = 0;
        }
        const input = document.getElementById(
          'search-route-input'
        ) as HTMLInputElement;
        if (input) {
          input.focus();
        }
      }, 100);
    } else {
      this.searchRouteQuery = '';
    }
  }

  onRouteSearchKeydown(event: KeyboardEvent, selectRef: MatSelect): void {
    if (event.key === 'Escape') {
      selectRef.close();
    } else if (event.key === 'Enter') {
      event.preventDefault();
      const visible = (this.availableProductRoutes || []).filter((r: string) =>
        this.isRouteVisible(r)
      );
      if (visible.length === 1) {
        this.toggleRouteSelection(visible[0]);
      }
    } else {
      event.stopPropagation();
    }
  }

  toggleRouteSelection(route: string): void {
    this.selectedRoutes = this.selectedRoutes || [];
    const index = this.selectedRoutes.indexOf(route);
    if (index > -1) {
      this.selectedRoutes = this.selectedRoutes.filter((r) => r !== route);
    } else {
      this.selectedRoutes = [...this.selectedRoutes, route];
    }
    this.applyFilterSelect();
  }

  clearSelectedRoutes(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    this.selectedRoutes = [];
    this.applyFilterSelect();
  }
}
